import * as Sentry from "@sentry/browser";
import {Integrations} from "@sentry/tracing";

const traceOrigins = process.env.SENTRY_TRACE_ORIGINS == "" ? ["mypage.caps-clinic.jp"] : process.env.SENTRY_TRACE_ORIGINS.split(",");
traceOrigins.push(/^\//);
const debug = process.env.SENTRY_DEBUG != "";

Sentry.init({
	dsn: process.env.SENTRY_DSN,
	integrations: [new Integrations.BrowserTracing({
		tracingOrigins: traceOrigins,
	})],
	tracesSampleRate: 0.2,
	attachStacktrace: true,
	debug: debug,
	environment: document.domain
});